var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_58",
    "data-name": "Group 58",
    transform: "translate(-22 -421)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_30",
    "data-name": "Ellipse 30",
    cx: 16,
    cy: 16,
    r: 16,
    transform: "translate(22 421)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "person",
    d: "M64.14,30.5a14.816,14.816,0,0,0,6.325,1.649A13.4,13.4,0,0,0,76.8,30.5a.269.269,0,0,0,.131-.231,8.674,8.674,0,0,0-1.878-5.6,6.105,6.105,0,0,0-3.083-2.009,3.5,3.5,0,1,0-3.01,0,6.106,6.106,0,0,0-3.083,2.009A8.674,8.674,0,0,0,64,30.266.269.269,0,0,0,64.14,30.5ZM67.5,19.49a2.963,2.963,0,1,1,2.963,2.963A2.963,2.963,0,0,1,67.5,19.49ZM66.29,25.008a5.332,5.332,0,0,1,8.35,0,8.088,8.088,0,0,1,1.75,5.1,13.185,13.185,0,0,1-5.926,1.5A14.438,14.438,0,0,1,64.54,30.1,8.086,8.086,0,0,1,66.29,25.008Z",
    transform: "translate(-32.395 412.779)",
    stroke: "#000",
    strokeWidth: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.4c938199c6e7d8ac449c9196b7836e68.svg";
export { ForwardRef as ReactComponent };